/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Filters_Searchplaceholder2Inputs */

const en_coinvestments_filters_searchplaceholder2 = /** @type {(inputs: Coinvestments_Filters_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search deals...`)
};

/**
* | output |
* | --- |
* | "Search deals..." |
*
* @param {Coinvestments_Filters_Searchplaceholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_filters_searchplaceholder2 = /** @type {((inputs?: Coinvestments_Filters_Searchplaceholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Filters_Searchplaceholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_filters_searchplaceholder2(inputs)
});
export { coinvestments_filters_searchplaceholder2 as "coInvestments_filters_searchPlaceholder" }